import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PasswordModule } from 'primeng/password';
import { ControlFieldComponent } from '../control-field/control-field.component';
import { PrimeNgControlComponent } from '../prime-ng-control/prime-ng-control.component';

@Component({
  selector: 'ui-password-field',
  standalone: true,
  imports: [PasswordModule, ControlFieldComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PasswordFieldComponent),
      multi: true,
    },
  ],
  templateUrl: './password-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordFieldComponent extends PrimeNgControlComponent<string> {}
